import React, { FC } from 'react';
import { SeparatorLine } from './Styles';
import { SeparatorProps } from './types';

export const Separator: FC<SeparatorProps> = ({ vertical = false }) => (
  <SeparatorLine vertical={vertical} />
);
